import { render, staticRenderFns } from "./AssessmentSection.vue?vue&type=template&id=2b20c92c&scoped=true&"
import script from "./AssessmentSection.vue?vue&type=script&lang=js&"
export * from "./AssessmentSection.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentSection.vue?vue&type=style&index=0&id=2b20c92c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b20c92c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VRow})
